import { render, staticRenderFns } from "./DrChronoAccount.vue?vue&type=template&id=889257fa&scoped=true&"
import script from "./DrChronoAccount.vue?vue&type=script&lang=ts&"
export * from "./DrChronoAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889257fa",
  null
  
)

export default component.exports